import { Link } from "react-router-dom";
import { Waveform } from "@phosphor-icons/react";

export function BrandMark({ size = 34 }) {
  return (
    <span
      className="flex items-center justify-center rounded-[10px] bg-ink text-white"
      style={{ height: size, width: size }}
    >
      <Waveform size={size * 0.56} weight="bold" />
    </span>
  );
}

export function Brand({ to = "/", sub, testId = "brand-link" }) {
  return (
    <Link to={to} data-testid={testId} className="flex items-center gap-2.5">
      <BrandMark />
      <span className="flex flex-col leading-none">
        <span className="font-display text-[17px] font-semibold text-ink">
          Speak<span className="font-normal text-mist">To</span>Prompt
        </span>
        {sub && <span className="mt-1 text-[11px] text-mist">{sub}</span>}
      </span>
    </Link>
  );
}
